module.exports = __webpack_public_path__ + "img/2160c4138c38104fcf8dcce57676d503.jpg";